import Iconify from 'src/components/Iconify';
import { TONE_SOFT } from 'src/design/tokens';
import { MKT } from '../marketing.design';

// Aliases de nomes usados nos call-sites originais (indigo/emerald/rose vindos
// de InstagramTab, "violet" vindo de OverviewTab) para os tons compartilhados.
const TONE_ALIAS = {
    violet: 'brand', brand: 'brand',
    pink: 'pink', rose: 'pink',
    blue: 'info', info: 'info',
    green: 'success', success: 'success', emerald: 'success',
    amber: 'warning', warning: 'warning', indigo: 'brand',
    red: 'danger', danger: 'danger',
};

const HEX_RE = /^#[0-9a-f]{3,8}$/i;

// `tone`/`color` aceitam uma chave de tom OU um hex de plataforma (ex.:
// '#1877F2' do Facebook). Antes, o colorMap so aceitava
// violet|pink|rose|blue|green|amber e caia pra violeta em silencio sempre que
// alguem passava um hex ou uma chave fora da lista — quebrava 12 cards em
// FacebookTab/GoogleAdsTab/InstagramTab (ver auditoria). Hex agora tinge o
// icon box via style inline, preservando a cor da plataforma pretendida.
export default function MetricCard({ icon, tone, color, iconColor, value, label, title, growth, prefix = '', suffix = '', hideIcon = false }) {
    const displayLabel = label || title;
    const showIcon = Boolean(icon) && !hideIcon;
    const raw = tone ?? color ?? iconColor ?? 'brand';
    const isHex = typeof raw === 'string' && HEX_RE.test(raw);

    const resolvedTone = isHex ? null : (TONE_ALIAS[raw] ?? 'brand');
    const soft = resolvedTone ? (TONE_SOFT[resolvedTone] ?? TONE_SOFT.brand) : null;

    const growthNum = parseFloat(growth);
    const growthClass = growthNum > 0
        ? MKT.stats.growth.positive
        : growthNum < 0
            ? MKT.stats.growth.negative
            : MKT.stats.growth.neutral;

    const growthPrefix = growthNum > 0 ? '+' : growthNum < 0 ? '−' : '';

    const formatValue = (val) => {
        if (typeof val === 'number') {
            if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
            if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
            return val.toLocaleString('pt-BR');
        }
        return val;
    };

    return (
        <div className={showIcon ? MKT.stats.card : MKT.stats.cardPlain}>
            {showIcon && (
                <div
                    className={`${MKT.stats.iconBox} ${soft ? soft.box : ''}`}
                    style={isHex ? { backgroundColor: `${raw}1A` } : undefined}
                >
                    <Iconify
                        icon={icon}
                        width={20}
                        className={soft ? soft.icon : ''}
                        style={isHex ? { color: raw } : undefined}
                    />
                </div>
            )}
            <div className={showIcon ? undefined : 'min-w-0'}>
                <p className={MKT.stats.value}>{prefix}{formatValue(value)}{suffix}</p>
                <p className={MKT.stats.label}>{displayLabel}</p>
                {growth !== undefined && growth !== null && !Number.isNaN(growthNum) && growthNum !== 0 && (
                    <span className={growthClass}>
                        {showIcon ? (
                            <Iconify
                                icon={growthNum > 0 ? 'eva:trending-up-fill' : growthNum < 0 ? 'eva:trending-down-fill' : 'eva:minus-fill'}
                                width={14}
                            />
                        ) : (
                            growthPrefix
                        )}
                        {Math.abs(growthNum).toFixed(1)}%
                    </span>
                )}
            </div>
        </div>
    );
}
